import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";
import Logo from "./Logo";
import { BRAND, CONTACT, SERVICE_META } from "../data/content";
import { useLang } from "../i18n";

const Footer = () => {
    const { t } = useLang();
    return (
        <footer data-testid="footer-section" className="border-t border-[#E3DCCF] bg-[#EFEADF]">
            <div className="mx-auto grid max-w-7xl gap-10 px-5 py-14 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <Logo />
                    <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#525B53]">
                        {t.footer.tagline}
                    </p>
                    <div className="mt-5 flex items-center gap-3">
                        <a
                            href={CONTACT.instagram}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-instagram"
                            className="inline-flex items-center gap-1.5 rounded-full border border-[#E3DCCF] bg-white px-3 py-1.5 text-[11px] font-semibold text-[#525B53] transition-colors hover:border-terracotta hover:text-terracotta"
                        >
                            <Instagram size={13} />
                            {CONTACT.instagramHandle}
                        </a>
                        <a
                            href={`https://wa.me/${CONTACT.whatsapp}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="footer-whatsapp"
                            aria-label="WhatsApp"
                            className="rounded-full border border-[#E3DCCF] bg-white p-2.5 text-olive transition-colors hover:border-terracotta hover:text-terracotta"
                        >
                            <MessageCircle size={18} />
                        </a>
                    </div>
                </div>

                <nav aria-label={t.footer.servicios}>
                    <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta">{t.footer.servicios}</h3>
                    <ul className="mt-4 space-y-2.5">
                        {SERVICE_META.slice(0, 6).map(({ slug }) => (
                            <li key={slug}>
                                <Link to={`/servicios/${slug}`} className="text-sm text-[#525B53] transition-colors hover:text-terracotta">
                                    {t.services[slug].nombre}
                                </Link>
                            </li>
                        ))}
                        <li>
                            <Link to="/servicios" className="text-sm font-semibold text-olive transition-colors hover:text-terracotta">
                                {t.footer.verTodos}
                            </Link>
                        </li>
                    </ul>
                </nav>

                <nav aria-label={t.footer.nosotros}>
                    <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta">{t.footer.nosotros}</h3>
                    <ul className="mt-4 space-y-2.5">
                        <li><Link to="/sobre-nosotros" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.sobre}</Link></li>
                        <li><Link to="/zona-de-servicio" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.zona}</Link></li>
                        <li><Link to="/faq" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.faq}</Link></li>
                        <li><Link to="/contacto" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.contacto}</Link></li>
                    </ul>
                </nav>

                <nav aria-label={t.footer.legal}>
                    <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta">{t.footer.legal}</h3>
                    <ul className="mt-4 space-y-2.5">
                        <li><Link to="/aviso-legal" data-testid="footer-legal-link" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.aviso}</Link></li>
                        <li><Link to="/privacidad" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.privacidad}</Link></li>
                        <li><Link to="/cookies" className="text-sm text-[#525B53] transition-colors hover:text-terracotta">{t.footer.cookies}</Link></li>
                    </ul>
                </nav>
            </div>

            <div className="border-t border-[#E3DCCF]">
                <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-5 py-5 text-xs text-[#7C877E] sm:flex-row sm:px-8">
                    <span>© {new Date().getFullYear()} {BRAND} · Maresme, Barcelona</span>
                    <span className="font-serif italic">{t.footer.claim}</span>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
